<template>
	<NuxtIcon
		v-if="isLoading"
		name="custom/loader"
		class="text-icon-primary animate-spin"
		filled
	/>
	<span v-else>
		<slot name="default" />
	</span>
</template>
<script setup lang="ts">
	interface Props {
		isLoading: boolean
	}

	withDefaults(defineProps<Props>(), {isLoading: false});
</script>
